import { useEffect, useState } from "react";
import { graphql, readInlineData } from "react-relay";

import { notEmpty } from "shared/lib/utils";

import type { hooksSectionMenuArticleSearchConnection$key } from "scmp-app/queries/__generated__/hooksSectionMenuArticleSearchConnection.graphql";

import { SectionOptions } from "./const";

export type SectionOptionWithCount = {
  count: string;
  text: string;
  value: string;
};

export function useSectionMenuOptions(reference: hooksSectionMenuArticleSearchConnection$key) {
  const data = readInlineData(
    graphql`
      fragment hooksSectionMenuArticleSearchConnection on ArticleSearchConnection @inline {
        aggregations {
          section {
            buckets {
              key
              doc_count
            }
          }
        }
      }
    `,
    reference,
  );

  const [options, setOptions] = useState<SectionOptionWithCount[]>([]);

  useEffect(() => {
    if (!notEmpty(data.aggregations?.section.buckets)) return;

    const buckets = new Map(
      data.aggregations.section.buckets.map(({ doc_count, key }) => [key, doc_count] as const),
    );

    setOptions([
      {
        count: "",
        text: "All",
        value: "",
      },
      ...SectionOptions.map(option => {
        const matched = buckets.get(option.value);
        return {
          ...option,
          count: matched?.toLocaleString() ?? "",
        };
      }),
    ]);
  }, [data.aggregations?.section.buckets]);

  return { options };
}
